<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
        <path stroke="#0069C4" stroke-linecap="square" stroke-width="2.5" d="M21 43.356l50.568.5"/>
        <g transform="translate(34 30)">
            <circle cx="12.788" cy="12.8" r="12" fill="#FFF" stroke="#313131" stroke-width="2.5"/>
            <path fill="#313131" d="M.553 12.68L12.998.233l1.415 1.414L1.968 14.094z"/>
            <path fill="#313131" d="M2.436 12l11.88 11.88-1.415 1.414-11.88-11.88z"/>
        </g>
    </g>
</svg>
